import React from 'react'
import Style from './categoryFilter.module.css'

const CategoryFilter = ({ options, value, onChange, label }) => (
    <div className={Style.filter} role="tablist" aria-label={label}>
        {options.map((option) => {
            const isActive = option.key === value
            return (
                <button
                    key={option.key}
                    type="button"
                    role="tab"
                    aria-selected={isActive}
                    className={[Style.option, isActive ? Style.active : ''].join(' ')}
                    disabled={option.count === 0 && !isActive}
                    onClick={() => onChange(option.key)}
                >
                    {option.label}
                    {typeof option.count === 'number' ? <span className={Style.count}>{option.count}</span> : null}
                </button>
            )
        })}
    </div>
)

export default CategoryFilter
